import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routes from './swagger.routes';
import uiBootstrap from 'angular-ui-bootstrap';

export class SwaggerComponent {
  constructor($rootScope, $scope, $state, $http, $cookies) {
    window.swaggerOAuth.authorizeUrl = '/api/interactiveDoc/authorize';
    window.setTimeout(() => {
      const bearerToken = $cookies.get('syncplicity-swagger-token');

      if(bearerToken && window.opener && window.opener.swaggerOAuth && window.opener.swaggerOAuth.tokenReceived){
        $cookies.remove('syncplicity-swagger-token');
        window.opener.swaggerOAuth.tokenReceived(bearerToken);
        window.close();
        $rootScope.$apply();
      }  
    }, 1000);
  }
}

SwaggerComponent.$inject = ['$rootScope', '$scope', '$state', '$http', '$cookies'];

export default angular.module('syncplicityLoginApp.Swagger', [uiRouter, 'swaggerUi', 'swaggerUiAuthorization'])
  .config(routes)
  .component('swagger', {
    template: require('./swagger.html'),
    controller: SwaggerComponent    
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/swagger/swagger.component.js